import { ApiService, ClinicGroup } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapClinicGroupToOptions = (clinics: ClinicGroup[]) => [
  { value: undefined, label: "All Clinic Groups", object: undefined },
  ...clinics.map((clinicGroup) => ({
    value: clinicGroup.name,
    label: clinicGroup.name,
    object: clinicGroup,
  })),
];

const ClinicGroupFilter = ({
  onChange,
  value,
}: {
  onChange: Function;
  value?: string;
}) => {
  return (
    <SelectSearchInput
      label="Clinic Group"
      field="Clinic Group"
      filter="name"
      onChange={onChange}
      mapToOptions={mapClinicGroupToOptions}
      apiService={ApiService.listClinicGroups}
    >
      <>{value || "All Clinic Groups"}</>
    </SelectSearchInput>
  );
};

export default ClinicGroupFilter;
